import React from "react";
import { colors, spacing, fonts } from "@/theme";

export function ScreenHeader({ title, subtitle, right }) {
  return (
    <div style={s.wrap}>
      <div>
        <div style={s.title} data-testid="screen-title">{title}</div>
        {subtitle ? <div style={s.subtitle}>{subtitle}</div> : null}
      </div>
      {right ? <div>{right}</div> : null}
    </div>
  );
}

const s = {
  wrap: {
    display: "flex", justifyContent: "space-between", alignItems: "flex-end",
    backgroundColor: colors.onSurface, padding: `${spacing.lg}px ${spacing.xl}px`,
    borderBottom: `2px solid ${colors.onSurface}`,
  },
  title: { ...fonts.display, fontSize: 26, color: colors.onSurfaceInverse, letterSpacing: 0, lineHeight: 1.1 },
  subtitle: { ...fonts.mono, fontSize: 12, color: colors.surfaceTertiary, marginTop: 4, letterSpacing: 0 },
};
